// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --configuration production` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: '/core',
  hubUrl: '/core/ChangeNotificationHub',
  workCenterId: -455,
  defaultLanguage: 'en',
  coreApiUrl: '/core',
  signalrBaseUrl: '/core/ChangeNotificationHub',
  liveApiUrl: '/live',
  pandaApiUrl: '/panda'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
